import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import ArticlePage from "../pages/article/page";
import ShoesArticlePage from "../pages/articles/shoes-spreadsheet/page";
import HoodiesArticlePage from "../pages/articles/hoodies-spreadsheet/page";
import TshirtsArticlePage from "../pages/articles/tshirts-spreadsheet/page";
import JacketsArticlePage from "../pages/articles/jackets-spreadsheet/page";
import AccessoriesArticlePage from "../pages/articles/accessories-spreadsheet/page";
import FashionArticlePage from "../pages/articles/fashion-spreadsheet/page";
import ShoppingTipsArticlePage from "../pages/articles/shopping-tips/page";
import ComparisonArticlePage from "../pages/articles/spreadsheet-comparison/page";
import SafetyArticlePage from "../pages/articles/safety-guide/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/kakobuy-spreadsheet-guide",
    element: <ArticlePage />,
  },
  {
    path: "/kakobuy-shoes-spreadsheet",
    element: <ShoesArticlePage />,
  },
  {
    path: "/kakobuy-hoodies-spreadsheet",
    element: <HoodiesArticlePage />,
  },
  {
    path: "/kakobuy-tshirts-spreadsheet",
    element: <TshirtsArticlePage />,
  },
  {
    path: "/kakobuy-jackets-spreadsheet",
    element: <JacketsArticlePage />,
  },
  {
    path: "/kakobuy-accessories-spreadsheet",
    element: <AccessoriesArticlePage />,
  },
  {
    path: "/kakobuy-fashion-spreadsheet",
    element: <FashionArticlePage />,
  },
  {
    path: "/kakobuy-shopping-tips",
    element: <ShoppingTipsArticlePage />,
  },
  {
    path: "/kakobuy-spreadsheet-comparison",
    element: <ComparisonArticlePage />,
  },
  {
    path: "/kakobuy-safety-guide",
    element: <SafetyArticlePage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;